import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { withStyles, createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { grey } from '@material-ui/core/colors';
import { InputAdornment, IconButton } from '@material-ui/core';
//import Visibility from '@material-ui/icons/Visibility';
//import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Icon from '@projeccions-pdc/react-icon';
let styles = () => ({
    resize: {
        fontSize: 14,
    },
});

const theme = createMuiTheme({
    palette: {
        primary: grey,
    },
});

class SimpleField extends Component {
    constructor(props) {
        super(props);
        this.state = { showPassword: false };
    }

    onShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    onChange = (evt) => {
        const name = this.props.name;
        const value = evt.target.value;
        const error = this.props.validate ? this.props.validate(value) : false;
        this.props.onChange({ name, value, error });
    };

    render() {
        let errorStyle = {
            color: 'rgb(159, 58, 56)',
            margin: '0',
            textAlign: 'left',
            backgroundColor: 'rgb(255, 246, 246) ',
            borderRadius: '.28571429rem',
            border: '1px solid rgb(224, 180, 180)',
            padding: '1em 1.5em',
            fontSize: '.78571429em',
        };

        return (
            <div>
                <ThemeProvider theme={theme}>
                    <TextField
                        label={this.props.placeholder}
                        value={this.props.value}
                        onChange={this.onChange}
                        error={this.props.error}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        type={this.state.showPassword ? 'text' : this.props.inputType}
                        autoComplete={this.props.autoComplete}
                        autoCapitalize="off"
                        style={{ fontSize: '12px' }}
                        InputLabelProps={{
                            classes: {
                                root: this.props.classes.resize,
                            },
                        }}
                        InputProps={{
                            classes: {
                                input: this.props.classes.resize,
                            },
                            endAdornment:
                                this.props.inputType === 'password' ? (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onTouchStart={this.onShowPassword}
                                            onTouchEnd={this.onShowPassword}
                                            onTouchCancel={this.onShowPassword}
                                            onMouseDown={this.onShowPassword}
                                            onMouseUp={this.onShowPassword}
                                            edge="end"
                                        >
                                            <Icon name={this.state.showPassword ? 'md-visibility-off' : 'md-visibility'} />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null,
                        }}
                        classes={{ root: this.props.classes.root }}
                        disabled={this.props.disabled}
                    />
                </ThemeProvider>
                {this.props.error && this.props.errorMessage !== undefined && <div style={errorStyle}>{this.props.errorMessage}</div>}
            </div>
        );
    }
}
SimpleField.propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    validate: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    inputType: PropTypes.string.isRequired,
    error: PropTypes.bool,
    autoComplete: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

export default withStyles(styles)(SimpleField);
